import { Card, Grid, Box, Typography, IconButton, Chip } from '@mui/material';
import React from 'react';
import PayPalImg from '../../Assets/paypalImg.png';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from 'react-router-dom';
import routes from '../../Utils/routes';
import { postJobsBookmark } from '../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';

export default function JobCards(props: any) {
  const { value, userData, isBookmarked, onBookmarkClick, setIsBookmarked, carrierJobs } = props;
  console.log('value324', value, onBookmarkClick);
  // let imageUrl = value?.Organization__r?.Logo_File_URL__c;
  // console.log('imageUrl12', imageUrl);

  // const fixedUrl = imageUrl?.replace(/&amp;/g, '');

  // console.log('fixedUrl34', fixedUrl);

  const navigate = useNavigate();
  const handleClick = () => {
    // navigate(`${routes.jobDetails}/${value?.Job_Title__c}-${value?.Id}`);
    navigate(`${routes.jobDetails}/${value?.Id}`, { state: { breadCrumbs: value?.Job_Title__c } });
  };

  const handleBookmark = () => {
    const payLoad = {
      contactId: userData.applicantId,
      jobId: value.Id,
      isBookmarked: !isBookmarked,
    };
    postJobsBookmark(payLoad, userData.applicantId)
      .then((res) => {
        setIsBookmarked(true);
        if (res?.success) {
          enqueueSnackbar({ message: 'Bookmark updated successfully', variant: 'success', autoHideDuration: 1000 });
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };

  const dateStr = value?.CreatedDate;
  const date = new Date(dateStr);

  const formattedDate = date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear();
  const workplaceType = value?.Work_Place_Type__c?.split(';');
  console.log('workplaceType2432', workplaceType);

  return (
    <div>
      <Card style={{ backgroundColor: '#F6F8FB', padding: 10, cursor: 'pointer', borderRadius: '9px', boxShadow: 'none' }}>
        <Grid container spacing={3}>
          <Grid item xs={2} sm={2} md={2} xl={2} lg={2}>
            <Box sx={{ height: '30px', width: '30px', background: '#FFFFFF', borderRadius: '6px', padding: '4px' }}>
              <img src={value?.Organization__r?.Logo_File_URL__c} height="20px" width="20px" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
            </Box>
          </Grid>
          <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
              <Typography
                fontWeight={'500'}
                sx={{
                  fontSize: '15px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '12px !important',
                  },
                }}
              >
                {value?.Job_Title__c}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
              <Typography
                fontWeight={'400'}
                sx={{
                  fontSize: '10.5px',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '10px !important',
                  },
                }}
              >
                {value?.Location__c}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} sm={2} md={2} xl={2} lg={2}>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <IconButton
                onClick={() => {
                  setIsBookmarked((prevState: any) => !prevState);
                  handleBookmark();
                }}
              >
                {isBookmarked ? <BookmarkIcon sx={{ color: '#585A64', fontSize: '20px' }} /> : <BookmarkBorderIcon sx={{ fontSize: '20px' }} />}
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        <Box onClick={handleClick}>
          <Box sx={{ display: 'flex', justifyContent: 'start', mt: 1 }}>
            {workplaceType?.map((val: any, idx: any) => {
              return <Chip label={val} size="small" sx={{ backgroundColor: 'white', color: '#1A358C', fontWeight: 400, fontSize: '9px', ml: idx == 0 ? 0 : 1 }} />;
            })}
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'start', mt: 2 }}>
            <WorkOutlineIcon fontSize="small" sx={{ fontSize: '12px' }} />{' '}
            <Typography fontWeight={'400'} fontSize={'9px'} style={{ marginLeft: 2 }}>
              Experience: {value?.Experience_Start_Level__c}-{value?.Experience_End_Level__c} years
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'start', mt: 1 }}>
            <CurrencyRupeeIcon fontSize="small" sx={{ fontSize: '12px' }} />{' '}
            <Typography fontWeight={'600'} fontSize={'10.5px'} style={{ marginLeft: 2 }}>
              {value?.Salary_Start_Range__c}-{value?.Salary_End_Range__c}
            </Typography>
          </Box>
          <Grid container spacing={2} sx={{ mt: 0.1 }}>
            {carrierJobs == 'PostedByMe' ? (
              <Grid item xs={6} sm={6} md={5} xl={5} lg={5}>
                <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                  <Chip label={'In-Review'} size="small" sx={{ backgroundColor: '#FEEBBE', color: '#1A358C', fontWeight: 400, fontSize: '9px' }} />
                </Box>
              </Grid>
            ) : (
              <>
                <Grid item xs={6} sm={6} md={2} xl={2} lg={2}>
                  <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                    <Typography fontWeight={'400'} fontSize={'9px'} sx={{ mt: 0.5 }}>
                      PostedBy:{' '}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={4} xl={4} lg={4} display={'flex'} justifyContent={'start'}>
                  {value?.Posted_By__r?.Name && <Chip label={value?.Posted_By__r?.Name} size="small" sx={{ backgroundColor: 'white', color: '#695113', fontWeight: 400, fontSize: '9px', ml: 0.5 }} />}
                </Grid>
              </>
            )}
            <Grid item xs={6} sm={6} md={5} xl={5} lg={5} xxl={4.5}>
              <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                <Typography fontWeight={'400'} fontSize={'9px'} sx={{ mt: 0.5 }}>
                  Posted on {formattedDate}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sm={6} md={1} xl={1} lg={1} xxl={1.5}>
              <Box sx={{ display: 'flex', justifyContent: 'start', mt: 0.5 }}>
                <EastIcon fontSize="small" sx={{ fontSize: '15px' }} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </div>
  );
}
